import { BookOpen, Building2, Globe, MapPin, Search, Sparkles } from "lucide-react";

export const SOURCES = [
  { key: "localch", label: "Local.ch", desc: "Annuaire suisse · détection de l'astérisque", icon: BookOpen, discovery: true },
  { key: "searchch", label: "Search.ch", desc: "Annuaire tel.search.ch · astérisque", icon: Search, discovery: true },
  { key: "google", label: "Google Maps", desc: "Places API · coordonnées, notes, sites", icon: MapPin, discovery: true, needsKey: "google_api_key" },
  { key: "zefix", label: "Registre du Commerce", desc: "Zefix · statut légal & dirigeants", icon: Building2 },
  { key: "crawler", label: "Deep Web Crawling", desc: "Emails, LinkedIn, Facebook, Instagram, formulaires", icon: Globe },
  { key: "enrichment", label: "Enrichissement API", desc: "Hunter.io / Apollo.io · email du dirigeant", icon: Sparkles, needsKey: "hunter_api_key|apollo_api_key" },
];

export const SOURCE_LABELS = {
  localch: "Local.ch",
  searchch: "Search.ch",
  google: "Google Maps",
  zefix: "Zefix",
  crawler: "Crawler",
  enrichment: "Enrichissement",
};

export const JOB_STATUS = {
  pending: { label: "En attente", cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  running: { label: "En cours", cls: "bg-blue-50 text-[#002FA7] border-blue-200" },
  paused: { label: "En pause", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Terminé", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  failed: { label: "Échoué", cls: "bg-red-50 text-[#FF3B30] border-red-200" },
  cancelled: { label: "Annulé", cls: "bg-zinc-100 text-zinc-500 border-zinc-200" },
  skipped: { label: "Ignoré", cls: "bg-zinc-50 text-zinc-500 border-zinc-200" },
};

export const PHASES = {
  queued: "En file d'attente",
  discovery: "Découverte multi-sources",
  zefix: "Validation Registre du Commerce",
  crawler: "Cloud Crawler (sites web)",
  enrichment: "Enrichissement API",
  done: "Terminé",
};

export const ACTIVE_STATUSES = ["pending", "running", "paused"];

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-CH", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
